// const isDate = date => date instanceof Date
const now = () => new Date()
const makeDate = date => date ? new Date(date) : now()

const WEEK_DAYS = [
  'chủ nhật',
  'thứ 2',
  'thứ 3',
  'thứ 4',
  'thứ 5',
  'thứ 6',
  'thứ 7',
]

const getDay = date => {
  let inst = makeDate(date)
  return WEEK_DAYS[inst.getDay()]
}

const getDate = date => {
  let inst = makeDate(date)
  return inst.getDate()
}

const getHours = date => {
  let inst = makeDate(date)
  return inst.getHours()
}

const getMinutes = date => {
  let inst = makeDate(date)
  return inst.getMinutes()
}

const getMonth = date => {
  let inst = makeDate(date)
  return inst.getMonth() + 1
}

const getYear = date => {
  let inst = makeDate(date)
  return inst.getFullYear()
}

const addSecond = (date, offset = 0) => {
  let inst = makeDate(date)
  return makeDate(inst.setSeconds(inst.getSeconds() + offset))
}

const addMinute = (date, offset = 0) => {
  let inst = makeDate(date)
  return makeDate(inst.setMinutes(inst.getMinutes() + offset))
}

const addHour = (date, offset = 0) => {
  let inst = makeDate(date)
  return makeDate(inst.setHours(inst.getHours() + offset))
}

const addDay = (date, offset = 0) => {
  let inst = makeDate(date)
  return makeDate(inst.setDate(inst.getDate() + offset))
}

const addMonth = (date, offset = 0) => {
  let inst = makeDate(date)
  return makeDate(inst.setMonth(inst.getMonth() + offset))
}

const formatStandard = date => {
  let inst = makeDate(date)
  return `${getYear(inst)}-${getMonth(inst)}-${getDate(inst)}`
}

const padLeftByZero = (num, len = 2) => (num != null) && num.toString().padStart(len, '0')

const formatDateLocaleVN = (date, sep = '/') => {
  let inst = makeDate(date)
  return [padLeftByZero(getDate(inst)), padLeftByZero(getMonth(inst)), getYear(inst)].join(sep)
}
const formatDateWithoutYearLocaleVN = (date, sep = '/') => {
  let inst = makeDate(date)
  return [padLeftByZero(getDate(inst)), padLeftByZero(getMonth(inst))].join(sep)
}
const formatTime = (date, sep = ':') => {
  let inst = makeDate(date)
  return [padLeftByZero(getHours(inst)), padLeftByZero(getMinutes(inst))].join(sep)
}

const isDateEqual = (d1, d2) => {
  const date1 = makeDate(d1)
  const date2 = makeDate(d2)
  return formatStandard(date1) === formatStandard(date2)
}

module.exports = {
  now,
  getHours,
  getMinutes,
  getDay,
  getDate,
  getMonth,
  getYear,
  addSecond,
  addMinute,
  addHour,
  addDay,
  addMonth,
  formatStandard,
  formatDateLocaleVN,
  formatDateWithoutYearLocaleVN,
  formatTime,
  isDateEqual
}
